import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const LockIcon = props => {
  return (
    <Svg
      width={16}
      height={21}
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path d="M6.5 14.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" fill="#5C697B" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.622 9.097l-.315-2.839a4.958 4.958 0 010-1.095l.022-.205a4.7 4.7 0 019.342 0l.023.205c.04.364.04.731 0 1.095l-.315 2.84.686.054c1.083.086 1.967.9 2.143 1.972a20.895 20.895 0 010 6.752 2.362 2.362 0 01-2.143 1.972l-1.496.12c-2.375.19-4.762.19-7.137 0l-1.497-.12a2.361 2.361 0 01-2.142-1.972 20.891 20.891 0 010-6.752 2.361 2.361 0 012.142-1.972l.687-.055zM7.626 2.3a3.2 3.2 0 013.554 2.825l.023.205c.028.254.028.51 0 .764l-.32 2.89a44.846 44.846 0 00-5.764 0l-.322-2.89a3.46 3.46 0 010-.764l.023-.205a3.2 3.2 0 012.806-2.825zm3.824 8.229a43.343 43.343 0 00-6.899 0l-1.496.12a.861.861 0 00-.782.719 19.39 19.39 0 000 6.267.861.861 0 00.782.719l1.496.12c2.296.183 4.603.183 6.899 0l1.496-.12a.861.861 0 00.781-.72 19.39 19.39 0 000-6.266.861.861 0 00-.781-.72l-1.496-.12z"
        fill="#5C697B"
      />
    </Svg>
  );
};

export default LockIcon;
